import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Zap } from 'lucide-react';
interface PitchSlideProps {
  content: {
    headline: string;
    link: string;
    text: string;
    urgency: string;
  };
}
export function PitchSlide({
  content
}: PitchSlideProps) {
  return <div className="bg-[#1C1C1C] rounded-2xl p-16 min-h-[600px] flex flex-col items-center justify-center relative overflow-hidden" data-id="element-204">
      {/* Accent borders */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#017C6D] to-[#0FB07D]" data-id="element-205" />
      <div className="absolute bottom-0 left-0 w-full h-2 bg-gradient-to-r from-[#0FB07D] to-[#017C6D]" data-id="element-206" />

      <motion.h2 initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5
    }} className="text-6xl font-extrabold text-white mb-12 text-center tracking-tight" data-id="element-207">
        {content.headline}
      </motion.h2>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3
    }} className="bg-[#017C6D] p-10 rounded-2xl shadow-2xl border border-[#0FB07D]/50 w-full max-w-3xl text-center mb-12" data-id="element-208">
        <h3 className="text-3xl font-bold text-white mb-6" data-id="element-209">
          View Our Packages:
        </h3>
        <div className="bg-white/10 py-4 px-8 rounded-xl inline-flex items-center gap-3 mb-8 border border-white/20" data-id="element-210">
          <span className="text-2xl font-mono text-[#0FB07D] font-bold" data-id="element-211">
            {content.link}
          </span>
          <ArrowRight className="text-white" data-id="element-212" />
        </div>
        <p className="text-2xl text-white/90 font-medium leading-relaxed" data-id="element-213">
          {content.text}
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.6
    }} className="flex items-center gap-4 bg-red-500/10 border border-red-500/30 py-4 px-8 rounded-full" data-id="element-214">
        <Zap className="text-red-500 w-6 h-6" data-id="element-215" />
        <p className="text-xl text-red-400 font-semibold" data-id="element-216">{content.urgency}</p>
      </motion.div>
    </div>;
}
export default PitchSlide;